import { GlFilteredSearchSuggestion } from '../../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../../../../../../../app/assets/javascripts/alert.js?vue3';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { __ } from '~/locale';
import BaseToken from '../../../../../../../../app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { OPTIONS_NONE_ANY } from '../constants';
import searchEpicsQuery from '../queries/search_epics.query.graphql';
export default {
    name: 'EpicToken',
    prefix: '&',
    separator: '::',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            epics: this.config.initialEpics || [],
            loading: false
        };
    },
    computed: {
        idProperty () {
            return this.config.idProperty || 'iid';
        },
        defaultEpics () {
            return this.config.defaultEpics || OPTIONS_NONE_ANY;
        }
    },
    methods: {
        fetchEpics (search = '') {
            return this.$apollo.query({
                query: searchEpicsQuery,
                variables: {
                    fullPath: this.config.fullPath,
                    search
                }
            }).then(({ data })=>data.group?.epics.nodes);
        },
        fetchEpicsBySearchTerm (search) {
            this.loading = true;
            this.fetchEpics(search).then((response)=>{
                this.epics = Array.isArray(response) ? response : response?.data;
            }).catch(()=>createAlert({
                    message: __('There was a problem fetching epics.')
                })).finally(()=>{
                this.loading = false;
            });
        },
        getActiveEpic (epics, data) {
            if (data && epics.length) {
                return epics.find((epic)=>this.getValue(epic) === data);
            }
            return undefined;
        },
        getValue (epic) {
            return this.getEpicIdProperty(epic).toString();
        },
        displayValue (epic) {
            return `${this.$options.prefix}${this.getEpicIdProperty(epic)}${this.$options.separator}${epic?.title}`;
        },
        getEpicIdProperty (epic) {
            return getIdFromGraphQLId(epic[this.idProperty]);
        }
    }
};
